import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { Button, Image } from 'react-bootstrap';
import $ from 'jquery';
import Calendar from '../../../../assets/img/calendar.svg'
// Import Style
import './DateRangePicker.scss';

const CUSTOM_RANGE_LABEL = 'Custom range';


class DatePicker extends Component {
  static defaultProps = {
    dateFormat: 'DD MMM YYYY',
    value: {
      startDate: moment().subtract(3, 'months').startOf('day'),
      endDate: moment().endOf('day'),
    },
  };
  constructor(props) {
    super(props);
    this.state = {
      fixStartDate: null,
      fixEndDate: null,
      label: '',
      ranges: {
        '1 week': [moment().subtract(1, 'week'), moment()],
        '2 weeks': [moment().subtract(2, 'weeks'), moment()],
        '1 month': [moment().subtract(1, 'months'), moment()],
        '3 months': [moment().subtract(3, 'months'), moment()],
        '6 months': [moment().subtract(6, 'months'), moment()],
        '1 year': [moment().subtract(1, 'year'), moment()]
      }
    };

    this.pickerRef = createRef();
  }

  componentDidMount() {
    this.setLabel();

    this.addButtons();
    this.addCheckBoxes();
    this.notificationBar();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value != this.props.value || prevProps.dateFormat != this.props.dateFormat) {
      this.setLabel();
      this.setCheckBoxes();
    }
  }

  notificationBar() {
    const calendarContainer = $('.daterangepicker .ranges');
    // Remove any existing notification first
    $('.daterangepicker .notification').remove();
    
    const customDate = this.state.fixStartDate && this.state.fixEndDate;
    
    const notification = $(
      `<div class="notification">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM11 9H13V7H11V9Z" fill="#FEFEFE"/>
        </svg>
        ${customDate 
          ? 'You have selected a fixed period. To enable a rolling period, choose one of the preset options like 1 week, 2 weeks, 1 month, etc.'
          : 'This period updates automatically each day. Fix either date to stop it from rolling.'
        }
      </div>`
    )
    notification.insertBefore(calendarContainer);
    this.markRollingPreset();
  }

  markRollingPreset() {
    const isRolling = !this.state.fixStartDate && !this.state.fixEndDate;
    $('.daterangepicker .ranges li').each((i, li) => {
      const preset = li.getAttribute('data-range-key');
      li.textContent = isRolling && $(li).hasClass('active') ? `${preset} · Rolling` : preset;
    });
  }

  addButtons() {
    // Add Today button handler
    const calendarContainer = $('.daterangepicker .calendar .daterangepicker_input');
    const btn = $(
      `<div class="btn-today-container"><Button class="todayBtn btn btn-sm btn-secondary" type="button">Today</Button></div>`
    );

    btn.children('button').on('click', ev => {
      const input = $(ev.target)
        .parents('.calendar')
        .find('input');
      input.val(moment().format(this.props.dateFormat));
      input.trigger('change.daterangepicker');
      this.handleDatesChanged();
    });
    btn.appendTo(calendarContainer);

    // Override default range buttons behavior except for Custom Range
    const rangeButtons = $(`.daterangepicker .ranges li:not(:contains("${CUSTOM_RANGE_LABEL}"))`);
    rangeButtons.off('mousedown').on('mousedown', ev => {
      ev.preventDefault();
      ev.stopPropagation();

      const picker = this.pickerRef.current.$picker.data('daterangepicker');
      const rangeName = $(ev.target).attr('data-range-key');
      const range = picker.ranges[rangeName];
      
      if (range) {
        picker.setStartDate(range[0]);
        picker.setEndDate(range[1]);
        picker.updateCalendars();
      }
      
      // Reset fixed dates and state when using predefined ranges
      const fixStartCheckbox = $('.calendar.left .btn-container input');
      const fixEndCheckbox = $('.calendar.right .btn-container input');
      fixStartCheckbox[0].checked = false;
      fixEndCheckbox[0].checked = false;
      fixStartCheckbox[0].disabled = false;
      fixEndCheckbox[0].disabled = false;

      this.setState({
        fixStartDate: false,
        fixEndDate: false
      }, () => {
        this.handleDatesChanged();
        this.notificationBar();
      });
      
      return false;
    });

    // Add handler for Custom Range button
    const customRangeButton = $(`.daterangepicker .ranges li:contains("${CUSTOM_RANGE_LABEL}")`);
    customRangeButton.on('mousedown', () => {
      const fixStartCheckbox = $('.calendar.left .btn-container input');
      const fixEndCheckbox = $('.calendar.right .btn-container input');
      
      fixStartCheckbox[0].checked = true;
      fixEndCheckbox[0].checked = true;
      
      this.setState({
        fixStartDate: true,
        fixEndDate: true
      }, () => {
        this.notificationBar();
      });
    });

    // Prevent default click behavior for predefined ranges only
    rangeButtons.off('click').on('click', ev => {
      ev.preventDefault();
      ev.stopPropagation();
      return false;
    });
  }

  addCheckBoxes() {
    const leftContainer = $('.calendar.left');
    const rightContainer = $('.calendar.right');

    const checkbox = (id, label, note) => $(
      `
      <div class="btn-container">
        <div class="calendar_check_box">
          <input name="${id}" type="checkbox"/>
          <span class="check_mark">
            <svg width="10px" height="10px" viewBox="0 0 12 10">
              <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
            </svg>
          </span>
          <label class="btn btn-secondary" title="${note}" for="${id}">${label}</label>
        </div>
        <div class="info">Stops this date from updating automatically</div>
      </div>
      `
    );

    const startDateCheckbox = checkbox('checkbox-1', 'Fix start date', 'Your dashboard view will fix the start date when enabled');
    const endDateCheckbox = checkbox('checkbox-2', 'Fix end date', 'Your dashboard view will fix the end date when enabled');

    const calendar = $('.calendar');
    calendar
      .on('mousedown.daterangepicker', 'td.available', ev => {
        this.handleDatesChanged();
        this.notificationBar();
      })
    calendar.find('.daterangepicker_input input')
      .on('change', ev => {
        this.handleDatesChanged();
        this.notificationBar();
      })
      .on('keydown', ev => {
        if (ev.key === 'Enter') {
          this.handleDatesChanged();
          this.notificationBar();
        }
      })
    // delegated, so it runs after the picker library has marked the preset that matches the typed dates
    calendar.on('change keydown', '.daterangepicker_input input', () => this.markRollingPreset());

    startDateCheckbox.on('click', ev => {
      ev.stopPropagation();
      const fixStartCheckbox = $('.calendar.left .btn-container input');
      if (!fixStartCheckbox[0].disabled) {
        fixStartCheckbox[0].checked = !fixStartCheckbox[0].checked;
        this.setState({
          fixStartDate: fixStartCheckbox[0].checked
        }, () => {
          this.notificationBar();
        });
      }
    });
    endDateCheckbox.on('click', ev => {
      ev.stopPropagation();
      const fixEndCheckbox = $('.calendar.right .btn-container input');
      const fixStartCheckbox = $('.calendar.left .btn-container input');
      
      if (!fixEndCheckbox[0].disabled) {
        fixEndCheckbox[0].checked = !fixEndCheckbox[0].checked;
      }
      
      if (fixEndCheckbox[0].checked) {
        fixStartCheckbox[0].checked = true;
        fixStartCheckbox[0].disabled = true;
        this.setState({
          fixStartDate: true,
          fixEndDate: true
        }, () => {
          this.notificationBar();
        });
      } else {
        fixStartCheckbox[0].disabled = false;
        fixStartCheckbox[0].checked = this.state.fixStartDate;
        this.setState({
          fixEndDate: false
        }, () => {
          this.notificationBar();
        });
      }
    });

    startDateCheckbox.appendTo(leftContainer);
    endDateCheckbox.appendTo(rightContainer);

    this.setCheckBoxes();
  }

  setCheckBoxes() {
    const { value } = this.props;
    const fixStartDate = value.fixedStartDate || value.customDate;
    const fixEndDate = value.customDate;
    const endDateMatchToday = moment(value.endDate).isSame(moment(), 'days');
    const fixStartCheckbox = $('.calendar.left .btn-container input');
    const fixEndCheckbox = $('.calendar.right .btn-container input');

    fixStartCheckbox[0].disabled = value.customDate;
    fixStartCheckbox[0].checked = fixStartDate;
    fixEndCheckbox[0].disabled = !endDateMatchToday;
    fixEndCheckbox[0].checked = fixEndDate;

    this.setState({
      fixStartDate,
      fixEndDate,
    }, () => {      
      this.notificationBar();
    });
  }

  setLabel() {
    const { value, dateFormat } = this.props;
    let label;

    let start = moment(value.startDate).format(dateFormat);
    let end = moment(value.endDate).format(dateFormat);
    label = start + ' - ' + end;

    this.setState({ label });
  }

  handleDatesChanged = () => {
    if (this.pickerRef.current) {
      const picker = this.pickerRef.current.$picker.data('daterangepicker');
      const endDateMatchToday = moment(picker.endDate).isSame(moment(), 'days');
      const fixStartCheckbox = $('.calendar.left .btn-container input');
      const fixEndCheckbox = $('.calendar.right .btn-container input');
      fixEndCheckbox[0].disabled = !endDateMatchToday;
      fixEndCheckbox[0].checked = !endDateMatchToday || this.state.fixEndDate;
      fixStartCheckbox[0].disabled = fixEndCheckbox[0].checked;
      fixStartCheckbox[0].checked = fixEndCheckbox[0].checked || this.state.fixStartDate;

      this.setState({
        fixStartDate: fixStartCheckbox[0].checked,
        fixEndDate: fixEndCheckbox[0].checked 
      }, () => this.notificationBar());
    }
  }

  handleChange = (event, picker) => {
    const customDate = this.state.fixStartDate && this.state.fixEndDate;
    const fixedStartDate = this.state.fixStartDate;
    
    const dates = {
      ...this.props.value,
      startDate: picker.startDate.startOf('day'),
      endDate: picker.endDate.endOf('day'),
      daysFromStart: picker.endDate.diff(picker.startDate, 'days'),
      fixedStartDate,
      customDate,
    };

    if (this.props.updateValue) {
      const update = this.props.dashboard && 
        (
          !this.props.dashboard.dataFrom ||
          moment(this.props.dashboard.dataFrom).isSameOrBefore(dates.startDate)
        );
      this.props.updateValue(dates, update);
      if (!this.props.disableSave && this.props.saveConfig) {
        this.props.saveConfig(update);
      }
    }
  };

  handleShow = () => {
    this.setCheckBoxes();
  }

  handleHide = () => {
    // Don't reset state to null on hide - this was causing the issue
    // where handleChange would see null values when saving
  }

  render() {
    const { dateFormat, value, switchConnection } = this.props;
    const { label, ranges } = this.state;

    return (
      <div className='datepicker'>
        <DateRangePicker
          locale={{ format: dateFormat, firstDay: 1, customRangeLabel: CUSTOM_RANGE_LABEL }}
          startDate={value.startDate}
          endDate={value.endDate}
          ranges={ranges}
          onApply={this.handleChange}
          onShow={this.handleShow}
          onHide={this.handleHide}
          ref={this.pickerRef}
        >
          <Button className='selected-date-range-btn'>
            <div className='pull-left'>
            <Image src={Calendar} />
            </div>
            <div className='pull-right'>
              <span>{label}</span>
              <span className='caret'></span>
            </div>
          </Button>
        </DateRangePicker>
        { switchConnection && (<div className='overlay' onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          switchConnection();
        }}></div>) }
      </div>
    );
  }
}

DatePicker.propTypes = {
  value: PropTypes.object,
  dateFormat: PropTypes.string,
  dashboard: PropTypes.object,
  saveConfig: PropTypes.func,
  updateValue: PropTypes.func,
};

export { DatePicker as DateRangePicker };
